import { Rpc } from '@dynamika/rpc-core/contracts';
import { viewerRpcScheme } from './scheme';

/** Registers Viewer events consumed by D7 sagas as Redux actions. */
export const registerViewerListeners = (
  dispatch: (action: { type: string; payload: unknown }) => void
): (() => void) => {
  const { listeners } = viewerRpcScheme;
  const listener = (type: string) => (payload: unknown) =>
    dispatch({ type, payload });

  const unsubscribers = [
    listeners.onReady(listener(Rpc.Events.Viewer.READY)),
    listeners.onStartListening(listener(Rpc.Events.Viewer.START_LISTENING)),
    listeners.onClosed(listener(Rpc.Events.Viewer.CLOSED)),
    listeners.onAttachForm(listener(Rpc.Events.Viewer.ATTACH_FORM)),
    listeners.onBusyChanged(listener(Rpc.Events.Viewer.BUSY_CHANGED)),
    listeners.onSeriesChanged(listener(Rpc.Events.Viewer.SERIES_CHANGED)),
    listeners.onStoreMeasurement(listener(Rpc.Events.Viewer.STORE_MEASUREMENT)),
    listeners.onSegmentationChanged(
      listener(Rpc.Events.Viewer.SEGMENTATION_CHANGED)
    ),
    listeners.onSegmentationSelected(
      listener(Rpc.Events.Viewer.SEGMENTATION_SELECTED)
    ),
    listeners.onSegmentationSaved(
      listener(Rpc.Events.Viewer.SEGMENTATION_SAVED)
    ),
    listeners.onSelectedLabels(listener(Rpc.Events.Viewer.SELECTED_LABELS)),
  ];

  return () => unsubscribers.forEach(unsubscribe => unsubscribe());
};
